// extracted by mini-css-extract-plugin
export default {"header":"Home_header__X1Amm","container":"Home_container__ptG-x","sectionTitle":"Home_sectionTitle__896mb","cardGrid":"Home_cardGrid__7C8Y9"};